<ng-container [formGroup]="form">
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>{{ "FORMS.REPLACEMENT_CLAIM_SCHEDULE_FORM.TIME" | translate }}</mat-label>
    <input matInput [formControlName]="givenFormControlName" type="time" />
    <mat-icon matIconSuffix>schedule</mat-icon>
    <app-error [control]="form.controls.givenFormControlName"></app-error>
  </mat-form-field>
</ng-container>
